import {Box} from '@mui/material'
import sectionDevider from '../assets/section-devider.png'

const SectionDivider = ({flipped = false}: {flipped?: boolean}) => (
  <Box
    component="img"
    src={sectionDevider}
    sx={{
      width: '100%',
      marginTop: flipped ? '-1px' : 0,
      transform: flipped ? 'rotate(180deg)' : 'none'
    }}
  />
)

export default SectionDivider
